<template>
  <view class="coupon-price {{numberDigit}} {{type}}">
    <text class="integer">{{valueObj.integer}}
    </text><text wx:if="{{valueObj.point}}" class="point">{{valueObj.point}}
    </text><text class="decimal">{{valueObj.decimal}}</text>
    <view class="desc">
      <view class="tip"> {{ tip }}  </view>
      <text class="unit">{{ couponInfo.max_benefit_capacity.unit }}</text>
    </view>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'
import { formatValue, getCouponTip } from '../../lib/utils'

createComponent({
  properties: {
    couponInfo: Object,
    type: String,
  },
  computed: {
    valueObj() {
      return formatValue(this.couponInfo.max_benefit_capacity.value)
    },
    tip() {
      return getCouponTip(this.couponInfo.type)
    },
    numberDigit() {
      if (String(this.valueObj.integer).length + String(this.valueObj.decimal).length + String(this.valueObj.point).length >= 3)
        return 'digit-3'
      else
        return ''
    },
  },
})
</script>

<style lang="stylus" scoped>
.coupon-price
  position relative
  font-size: 100rpx;
  font-family: DIN-Bold, DIN-Bold-self;
  color: #E33C2B;
  text-shadow: 1px 1px 0px #FFF;
  line-height 1
  display: flex;
  align-items: center;
  justify-content: center;
  height 100%
  &.digit-3
    .point
      margin-left 0
      margin-right -8rpx
    .integer
      letter-spacing: -4rpx;
  &.popup-result
    font-size 100rpx
    &.digit-3
      font-size 96rpx
      .tip
        margin-bottom: 12rpx
    .tip
      margin-bottom: 20rpx
  .point
    margin-left -4rpx
    margin-right -14rpx
  .desc
    display flex
    flex-direction column
  .unit
    font-size: 36rpx;
    font-family: PingFang SC;
    font-weight: 800;
    color: #E33C2B;
    text-shadow: 1px 1px 0px #FFF;
    position relative
    right: -8rpx
  .tip
    text-shadow: none
    width: 56rpx;
    height: 25rpx;
    background: #F3B651;
    border-radius: 13rpx 13rpx 13rpx 0;
    box-shadow: 1px 1px 0 0 rgba(255, 255, 255, 0.7);
    font-size: 18rpx;
    font-family: PingFang SC;
    font-weight: 300;
    color: #FFF;
    text-align center
    line-height 28rpx
    margin-bottom: 24rpx
    margin-left 8rpx
</style>

<script type="application/json" lang="json">
{
  "component": true
}
</script>
